import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Persona } from 'src/app/models/persona';
import { PersonaService } from 'src/app/services/persona.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {MustMatch} from  '../validadores/machaPassword';
import swal from 'sweetalert2';
@Component({
  selector: 'app-password-inicial',
  templateUrl: './password-inicial.component.html',
  styleUrls: ['./password-inicial.component.css']
})
export class PasswordInicialComponent implements OnInit {
  changeForm: FormGroup;
  summited: Boolean;
  error: {code: number, message: string}= null;
  actuario:Persona = new Persona();
  //passwordPattern: any=/^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,12}$/;
  passwordPattern: any= /^(?=.{8,17}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\u0040\u0024\u0026]).*$/;

  constructor(private service: PersonaService, 
    private router: Router,
    private formBuilder:FormBuilder,
    private activateRouter: ActivatedRoute) { 
    
    }
    
  ngOnInit(): void {
    this.cargaActuario();
    this.changeForm = this.formBuilder.group({
      correo: ['', [Validators.required, Validators.email]],
      ingresoNuevo:['', [Validators.required, Validators.minLength(8), Validators.pattern(this.passwordPattern)]],
      confirmaIngreso:['', Validators.required]},{
        validator: MustMatch('ingresoNuevo', 'confirmaIngreso')
      });
      this.changeForm.get("correo").disable();
  }
  cargaActuario():void{
    this.activateRouter.params.subscribe(
      params => {
        let id = params['id'];
        if(id){
          this.service.getPersona(id).subscribe((persona) => this.actuario=persona)
        }
      }
    )
     
  }
  get f() {
    return this.changeForm.controls;
  }
  onResetForm(){
    this.changeForm.reset();
  }
  submitChange():void{
    this.actuario.pass = this.changeForm.get("ingresoNuevo").value;
    console.log("persona: " + this.actuario.nombre)
     this.service.cambiaIngreso(this.actuario).subscribe(response => {
       this.router.navigate(['/login'])
       swal.fire('Password Actualizado', 'SE REDIRECCIONARA A LOGIN PARA ENTRAR CON EL NUEVO PASSWORD GENERADO', 'success');
      })
    }
  
  get correo(){return this.changeForm.get("correo")}
  get ingresoNuevo(){return this.changeForm.get("ingresoNuevo")}
  get confirmaIngreso(){return this.changeForm.get("confirmaIngreso")}

}
